// src/pages/QbusAutomations/NodeConfigPanel.jsx
// Switchboard that renders the correct config panel for a selected node
import React from 'react';
import { Typography } from '@mui/material';
import OutputStateChangedConfig from './panels/OutputStateChangedConfig';
import CheckAlarmActiveConfig from './panels/CheckAlarmActiveConfig';
import CheckOutputStateConfig from './panels/CheckOutputStateConfig';
import CheckControllerOnlineConfig from './panels/CheckControllerOnlineConfig';
import CheckTimeConfig from './panels/CheckTimeConfig';
import CheckDayOfWeekConfig from './panels/CheckDayOfWeekConfig';
import SetOutputConfig from './panels/SetOutputConfig';
import SetMultipleOutputsConfig from './panels/SetMultipleOutputsConfig';
import ActivateControllerConfig from './panels/ActivateControllerConfig';
import RefreshHubConfigConfig from './panels/RefreshHubConfigConfig';
import TriggerAlarmConfig from './panels/TriggerAlarmConfig';
import HttpRequestConfig from './panels/HttpRequestConfig';
import CaroApiRequestConfig from './panels/CaroApiRequestConfig';
import DelayConfig from './panels/DelayConfig';
import LogMessageConfig from './panels/LogMessageConfig';
import SendNotificationConfig from './panels/SendNotificationConfig';
import ApiWebhookConfig from './panels/ApiWebhookConfig';
import ExtractParamsConfig from './panels/ExtractParamsConfig';
import RegexExtractConfig from './panels/RegexExtractConfig';
import IfConditionConfig from './panels/IfConditionConfig';
import { AndConditionConfig, OrConditionConfig } from './panels/LogicGateConfig';
import JsonBuilderConfig from './panels/JsonBuilderConfig';
import FunctionBlockConfig from './panels/FunctionBlockConfig';
import InternalEventConfig from './panels/InternalEventConfig';
import { ParallelConfig, ParallelJoinConfig } from './panels/ParallelConfig';

const panelMap = {
  output_state_changed: OutputStateChangedConfig,
  api_webhook: ApiWebhookConfig,
  internal_event: InternalEventConfig,
  if_condition: IfConditionConfig,
  and_condition: AndConditionConfig,
  or_condition: OrConditionConfig,
  check_alarm_active: CheckAlarmActiveConfig,
  check_output_state: CheckOutputStateConfig,
  check_controller_online: CheckControllerOnlineConfig,
  check_time: CheckTimeConfig,
  check_day_of_week: CheckDayOfWeekConfig,
  set_output: SetOutputConfig,
  set_multiple_outputs: SetMultipleOutputsConfig,
  activate_controller: ActivateControllerConfig,
  refresh_hub_config: RefreshHubConfigConfig,
  trigger_alarm: TriggerAlarmConfig,
  http_request: HttpRequestConfig,
  caro_api_request: CaroApiRequestConfig,
  delay: DelayConfig,
  log_message: LogMessageConfig,
  send_notification: SendNotificationConfig,
  extract_params: ExtractParamsConfig,
  regex_extract: RegexExtractConfig,
  json_builder: JsonBuilderConfig,
  function_block: FunctionBlockConfig,
  parallel: ParallelConfig,
  parallel_join: ParallelJoinConfig,
};

const NodeConfigPanel = ({ node, locationId, onChange }) => {
  const PanelComponent = panelMap[node.data.blockType];

  if (!PanelComponent) {
    return (
      <Typography variant="body2" color="text.secondary">
        No configuration panel for block type: {node.data.blockType}
      </Typography>
    );
  }

  const handleConfigChange = (newConfig) => {
    onChange({ config: newConfig });
  };

  const handleSummaryChange = (summary) => {
    onChange({ summary });
  };

  return (
    <PanelComponent
      config={node.data.config || {}}
      locationId={locationId}
      onChange={handleConfigChange}
      onSummaryChange={handleSummaryChange}
    />
  );
};

export default NodeConfigPanel;
